import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./MyEventNew.css";
import TopSectionEvents from "./TopSectionEvents";
import { getEventsForUser } from "../../services/eventService";
import { getUserDetails } from "../../services/authService";

function MyEventNew() {
  const history = useHistory();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [userData, setUserData] = useState(null);


  useEffect(() => {
    const fetchEventsAndUser = async () => {
      try {
        const loggedInUserId = localStorage.getItem("registeredUsername") || "0";
        const [eventsData, userRes] = await Promise.all([
          getEventsForUser(loggedInUserId),
          getUserDetails(localStorage.getItem("user_id")),
        ]);
  
        setEvents(eventsData);
        if (userRes.success) setUserData(userRes.user);
      } catch (error) {
        console.error("Failed to fetch events or user data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEventsAndUser();
  }, []);
  const navigateToEditProfile = () => {
    const userId = localStorage.getItem("user_id");
    if (!userId || !userData) return;
    history.push(`/user-details/${userId}`, { to_update: true, userData });
  };
  

  const handlePopup = (text) => {
    setPopupText(text);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const navigateToCreateEvent = () => {
    history.push("/create-new-event", {
      username: localStorage.getItem("registeredUsername") || "0",
    });
  };

  const navigateToEventManager = (eventItem) => {
    history.push("/gallery-manager", { eventData: eventItem });
  };

  const navigateToHome = () => {
    history.push("/");

  };

  const filteredEvents = events.filter((eventItem) =>
    eventItem.event_name?.toLowerCase().includes(searchText.toLowerCase())
  );

  const username = localStorage.getItem("registeredUsername") || "0";

  return (
    <div className="main-container">
      <TopSectionEvents
        title={`שלום הצלם ${username}`}
        searchValue={searchText}
        onSearchChange={setSearchText}
      />

      <div
        className={`bottom-section-event blur-background blur-bottom ${isExpanded ? "expanded" : ""}`}
      >
        {!loading && filteredEvents.length > 0 && (
          <div className="show-toggle-wrapper bottom-section-top-events ">
            <button
              className="show-all-event-btn"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              <span className="show-all-event-text">
                {isExpanded ? "הצג פחות" : "הצג הכל"}
              </span>
            </button>
            <div className="last-events-section">
              <span className="last-events-text">אירועים אחרונים</span>
              <img src="/icons/last_events.png" className="last-events-icon" alt="Last Events" />
            </div>
          </div>
        )}

        <div className="gallery-container-event">
          {loading ? (
            <div className="loading-message">טוען אירועים...</div>
          ) : filteredEvents.length === 0 ? (
            <div className="no-events-message">
              לא נמצאו אירועים התואמים לחיפוש
            </div>
          ) : (
            <div className="image-gallery-event">
              {filteredEvents.map((eventItem, idx) => (
                <div
                  key={idx}
                  className="image-item-event"
                  onClick={() => navigateToEventManager(eventItem)}
                >
                  <div className="image-container-event">
                    <img
                      src={eventItem.intro_image_url || "/images/default_event_image.png"}
                      alt={`Event Intro ${idx}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/images/default_event_image.png";
                      }}
                    />
                  </div>
                  <div className="image-details-2">
                    <div className="image-details-3">
                      <div className="event-title">{eventItem.event_name}</div>

                    </div>
                    <div className="image-details-event">
                      <div className="event-date-location">
                        <span className="event-date">
                          <img src="/icons/date.png" alt="Calendar Icon" />
                          {eventItem.event_date || "לא צוין תאריך"}
                        </span>
                        <span className="event-location">
                          <img src="/icons/location.png" alt="Location Icon" />
                          {eventItem.event_location || "לא צוין מיקום"}
                        </span>
                      </div>
                      <img className="enter-event-img" src="/icons/enter_event.png" alt="enter" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="action-bar-event">
      <button className="action-item-event" onClick={navigateToEditProfile}>
          <img src="/icons/edit.png" alt="Edit Icon" className="action-icon-event" />
        </button>
        <button className="action-item-circular-button" onClick={navigateToCreateEvent}>
          <span className="action-button-text">צור אירוע</span>
          <img src="/icons/add.png" alt="Add Icon" className="action-icon-event" />
        </button>
        <button className="action-item-event" onClick={navigateToHome}>
          <img src="/icons/home.png" alt="Home Icon" className="action-icon-event" />
        </button>


      </div>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <button className="popup-close-btn" onClick={closePopup}>
              &times;
            </button>
            <div className="popup-content">
              <img src="/icons/v.png" alt="Check Icon" className="v-icon" />
              <span className="popupText">{popupText}</span>
              <img src="/icons/line_g.png" alt="Line Icon" className="line-icon" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MyEventNew;
